<template>
    <div class="container">
        <search-bar-multi-key :search-design="data.data" />
    </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { PageComponentInterface } from '../Interfaces/PageComponentInterface';
import SearchBarMultiKey from "../../../Components/SearchBar/SeachBarMutliKeyword.vue";

export default defineComponent({
	name: "SearchBarSection",
    components: {
        SearchBarMultiKey,
    },
    props: {
        data: {
            type: Object as PropType<PageComponentInterface>,
			required: true,
        }
    }
});
</script>